'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["iconName", "tooltip", "placement", "onClick", "disabled", "disabledTooltip"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UITextToolbarButton from '../editor/UITextToolbarButton';
import UITextToolbarIcon from '../editor/UITextToolbarIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default class ToolbarButton extends Component {
  render() {
    const _this$props = this.props,
      {
        iconName,
        tooltip,
        placement,
        onClick,
        disabled,
        disabledTooltip
      } = _this$props,
      buttonProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const isTooltipDisabled = disabled && !disabledTooltip;
    const tooltipTitle = disabled ? disabledTooltip : tooltip;
    return /*#__PURE__*/_jsx(UITooltip, {
      disabled: isTooltipDisabled,
      title: tooltipTitle,
      placement: placement,
      children: /*#__PURE__*/_jsx(UITextToolbarButton, Object.assign({
        onClick: onClick,
        disabled: disabled
      }, buttonProps, {
        children: /*#__PURE__*/_jsx(UITextToolbarIcon, {
          disabled: disabled,
          name: iconName
        })
      }))
    });
  }
}
ToolbarButton.propTypes = {
  iconName: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired,
  placement: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  disabledTooltip: PropTypes.string
};
ToolbarButton.defaultProps = {
  placement: 'bottom'
};